import React from 'react';
import { BellIcon, HomeIcon, IdCardIcon, LayoutGridIcon, SparklesIcon, UserRoundIcon } from 'lucide-react';
import { citizenFirstName, mobileItems } from '../../data/espace';
export function PhoneMockup() {
  return <div aria-hidden="true" className="mx-auto w-[280px] rounded-[2.5rem] border-[10px] border-ville-navy bg-white shadow-2xl shadow-ville-navy/25" data-id="element-1085" data-mp="1s1i2vy60sm49">
      <div className="flex h-[560px] flex-col overflow-hidden rounded-[1.8rem]" data-id="element-1086" data-mp="2kpdyezjus7zg">
        <div className="flex items-center justify-between px-5 pt-5" data-id="element-1087" data-mp="2kn9skc2e8ywj">
          <span className="text-[15px] font-extrabold text-ville-navy" data-id="element-1088" data-mp="2pnfs0eewnpp6">Bonnyville</span>
          <span className="relative grid h-8 w-8 place-items-center rounded-full bg-slate-100 text-ville-navy" data-id="element-1089" data-mp="2aq59il3uhjjy">
            <BellIcon className="h-4 w-4" data-id="element-1090" data-mp="2fo6q8zdst6s9" />
            <span className="absolute -right-0.5 -top-0.5 h-3 w-3 rounded-full bg-red-600 ring-2 ring-white" data-id="element-1091" data-mp="zc1hhkgti5hj" />
          </span>
        </div>

        <div className="px-5 pt-5" data-id="element-1092" data-mp="14cfocz6on9dz">
          <p className="text-xl font-extrabold tracking-tight text-ville-navy" data-id="element-1093" data-mp="148i4ucg70ftk">Hello {citizenFirstName}</p>
          <div className="mt-3 flex items-center gap-2 rounded-full border border-slate-200 px-3 py-2" data-id="element-1094" data-mp="2vmwvfi14uiqq">
            <SparklesIcon className="h-4 w-4 text-ville-indigo" data-id="element-1095" data-mp="39mg1m5advk0e" />
            <span className="text-xs text-slate-400" data-id="element-1096" data-mp="39nzf5o4nngyh">What can I do for you?</span>
          </div>
        </div>

        <div className="mt-5 flex-1 px-5" data-id="element-1097" data-mp="34pxz7c2izxr8">
          <p className="text-xs font-bold uppercase tracking-wider text-slate-500" data-id="element-1098" data-mp="3jk2hov3f5hly">For you</p>
          <ul className="mt-2.5 space-y-2.5" data-id="element-1099" data-mp="3emkivxj48iro">
            <li className="rounded-2xl border-l-4 border-red-600 bg-slate-50 px-4 py-3" data-id="element-1100" data-mp="3elixp08dyfw8">
              <p className="text-[11px] font-bold uppercase tracking-wider text-red-600" data-id="element-1101" data-mp="3sce7qfumf31e">Urgent</p>
              <p className="text-sm font-bold text-ville-navy" data-id="element-1102" data-mp="3ocdugyj9cxvx">Boil water advisory</p>
              <p className="text-xs text-slate-500" data-id="element-1103" data-mp="66r3jm0itdc7">5108 - 46 Street</p>
            </li>
            {mobileItems.map(item => <li key={item.id} className="rounded-2xl border border-slate-200 px-4 py-3" data-id="element-1104" data-mp="14s0yeclukgb">
                <p className="text-sm font-bold text-ville-navy" data-id="element-1105" data-mp="2uwrmmljekgsm">{item.eyebrow}</p>
                <p className="text-xs text-slate-500" data-id="element-1106" data-mp="2z0zayhly7uqb">{item.detail}</p>
              </li>)}
          </ul>
        </div>

        <nav className="mt-4 flex items-end justify-between border-t border-slate-100 px-5 pb-5 pt-3" data-id="element-1107" data-mp="33xpvbh4sdchj">
          {[{
          icon: HomeIcon,
          label: 'Home',
          active: true
        }, {
          icon: IdCardIcon,
          label: 'Card',
          active: false
        }].map(tab => <span key={tab.label} className={`flex w-12 flex-col items-center gap-1 text-[10px] font-semibold ${tab.active ? 'text-ville-navy' : 'text-slate-400'}`} data-id="element-1108" data-mp="3imlxixk5vva8">
              <tab.icon className="h-5 w-5" data-id="element-1109" data-mp="1sc97szsw6bxi" />
              {tab.label}
            </span>)}

          <span className="flex w-12 flex-col items-center gap-1 text-[10px] font-bold text-ville-indigo" data-id="element-1110" data-mp="1xau8f0c22xmh">
            <span className="grid h-11 w-11 -translate-y-2 place-items-center rounded-full bg-ville-indigo text-white shadow-lg shadow-ville-indigo/40" data-id="element-1111" data-mp="1ps36kzvnwzkn">
              <SparklesIcon className="h-5 w-5" data-id="element-1112" data-mp="1kzjobpm15g9i" />
            </span>
            <span className="-mt-1" data-id="element-1113" data-mp="1g2t9t6pvisq7">ATNA</span>
          </span>

          {[{
          icon: LayoutGridIcon,
          label: 'Services'
        }, {
          icon: UserRoundIcon,
          label: 'Profile'
        }].map(tab => <span key={tab.label} className="flex w-12 flex-col items-center gap-1 text-[10px] font-semibold text-slate-400" data-id="element-1114" data-mp="28pxc33xl0sya">
              <tab.icon className="h-5 w-5" data-id="element-1115" data-mp="23pjdsdls8xdg" />
              {tab.label}
            </span>)}
        </nav>
      </div>
    </div>;
}